import { inject, Service } from "@angular/core";
import { Auth, signOut } from "@angular/fire/auth";
import { EMPTY, from, Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";

import { ApiService } from "../api/local-144/api.service";
import { getAccountInfo } from "../api/local-144/fn/accounts/get-account-info";
import { getServerState } from "../api/local-144/fn/root/get-server-state";
import { Accounts } from "../api/local-144/models/accounts";
import { setLoadingAndError } from "../common/rxjs/set-loading-and-error.operator";
import { AppStore } from "./app.store";

@Service()
export class AppService {
    private readonly api = inject(ApiService);
    private readonly auth = inject(Auth);
    private readonly store = inject(AppStore);

    public loadServerState(): Observable<void> {
        return this.api.invoke(getServerState).pipe(
            setLoadingAndError(this.store),
            map((serverState) => {
                this.store.setServerState(serverState);
            }),
            catchError(() => EMPTY)
        );
    }

    public loadCurrentAccount(): Observable<Accounts> {
        const currentAccount = this.store.currentAccount();
        if (currentAccount) {
            return of(currentAccount);
        }

        return this.api.invoke(getAccountInfo).pipe(
            setLoadingAndError(this.store),
            tap((account) => {
                this.store.setCurrentAccount(account);
            })
        );
    }

    public logout(): Observable<void> {
        return from(signOut(this.auth)).pipe(
            tap(() => {
                this.store.setCurrentAccount(null);
            })
        );
    }
}
